var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLandscapeRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 385.48 48.23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2 {\n        fill: #fe2215;\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5, .cls-6 {\n        stroke-width: 0px;\n      }\n\n      .cls-1, .cls-3, .cls-6 {\n        fill-rule: evenodd;\n      }\n\n      .cls-3, .cls-4 {\n        fill: #fff;\n      }\n\n      .cls-5, .cls-6 {\n        fill: #dadada;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Livello_1",
    "data-name": "Livello 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "path21178-04",
    className: "cls-2",
    d: "M149.82,18.26l-1.33,5.15v8.55h-12.23v-1.57h-1.54v-2.7h-2.3l-.15-.87h-3.78v-2.01h-.58v7.24h-1.42v-1.4h-1.15v1.61h-4.03v-1.92h-5.99v-4.58h-.85v-.52h-.85l-.7.26v.65h-.48v1.61h-1.85l.3-.74h-2.03l.18.96h-1.39v5.41h-1.94v-3.75h-1.24v3.05h-2.97l-.82-4.32-.85-1.27h-4.24v-5.15l-.85-4.49-.85,4.54v7.68l-1.12-.44v-2.36h-3v3.75h-1.06v4.58h-2.12v-5.15h-1.36l-.76,4.06h-3.97v-6.54h-.88v3.49h-5.39v2.7c-.06,0-.09.04-.15.09-1.12,1.57-2.81-1.09-3.93.65-.54,1.18-.97,0-1.6-.22-.39.74-1.12,1.4-2.03,1.57v-1.44h-1.33c-.36-.92-1.03-1.66-2.09-.79-.21-.09-.42-.13-.64-.22v-4.14h-2.06c-.24-.22-.42-.52-.24-.92,0-1.4-1.88.04-2.12-1.27-.36-1.18-1.57-1.53-2.45-.79-.88.39-1.73.92-2.48,1.53v-1.05h-.58v.74c-.21-.35-.48-.7-.94-.79-.82-.39-1.76-1.66-2.57-1.22-.42,1.05-.97,2.05-1.51,3.05-.39,1.4-1.39.17-1.88.31-1.06.26-.48,2.36-1.76,2.18-.94-.44-1.94-.09-2.33,1-.67.35-1.06.13-1.3-.65-.64-.31-.97-.09-1.18.35l-.45-1.13-1.45,3.66-2.39-.92-1.12-1.61h-2.3v4.97h-1.24v-12.26l-1.36-.52v5.72h-3.66v6.54h-3.18v4.14h-1.94v-1.75h-4.66l-2.6-3.75-1.69,2.44h-4.81v2.36h-1.91v-2.09h-.97v3.75h-1.85v4.71H.33l-.33,2.18h385.48v-1.53l-.33-1.79-2.36-2.36v-2.14l-1.54-.61v-2.53l-1.97.79v2.75h-2.33v-.35h-2.33v-.22l-3,2.36v-1.88h-2.45c0-.26.03-.48.06-.74.21-.79-.54-1.18-.91-1.44-.24-.87-.24-2.18-1.63-1.7-.24.61-.64.79-1.3.52v-1.31h-1.88l-.42-2.27h-1.73l-.24,1.22c-.51.09-1.33.7-1.69-.22-.54-.74-1.09-1.48-1.51-2.27-.82-.31-1.76.65-2.57.92-.7.09-.94.7-1.27.96-.82-.48-1.79-.96-2.72-1.27-.85-.57-2.06-.31-2.45.57-.24,1-2.12-.09-2.12.96.45.92-1.76.96-.94,1.61-.09.52,1.18.96.18,1.35,0,.09.06.17.06.22h-.24l-.82-4.36-1.94.74-.48-2.62h-1.24v4.58h-1.06v-1.7h-2.03l-3,1.18v2.7h-2.15l-.36-2.01h-1.85v-10.47s-.36-.35-.97-.35,0,8.77,0,8.77h-1.82l-1.39-3.45-2,4.97-2.42-3.49-2.3,3.36h-1.15v-2.09h-1.36v6.94h-1.24v-3.93h-1.57l-.27-1.48h-1.45v1.66h-2.6v-2.79l-1.15.44v-2.66h-1.15v-1.22h-1.27l-.88-8.9-.67,8.73v6.24h-1.15v-1.4h-3.09v4.32h-2.33v-2.92h-1.94v-6.67h-1.91v-1.13h-1.69l-1-2.53-1.63,4.06h-2v5.28h-1v-2.88l-3.48-1.35v3.23h-1.97v-4.1h-3.21v3.05c-.15-.39-.39-.7-.7-1,.18-2.62-2.3-1.35-2.97-2.53-1.15.04-1.6,0-1.42-1.66-.82-1.22-3.09-3.27-4.6-1.4-1.12,2.36-2.81-1.7-3.93.96-.54,1.75-.97,0-1.6-.31-.24.7-.61,1.31-1.06,1.79v-1.27h-.97v1.88c-.3.09-.64.09-.97,0-.09-1.18-.79-5.5-2.45-3.36-1.12-.65-2.57-.87-3.48.79-1.57-1.44-1.88,2.62-2.15,3.93-.21-.04-.42-.09-.61-.04h-.06c-1.09.17-1.63,1.7-1.33,3.14h-.3v2.84h-2.78v-2.57l-2.06.79v-6.02l.48-1.22v-1.88h-4.69v1.83l.64,1.57v5.37l-2.12.83v-2.05h-3.54v-2.27h-3.78v-3.45l-1.54-8.25-1.57,8.38v7.37h-1.97v-2.97h-5.33v2.09h-4.3v3.14h-2.78v-8.42h-1.97v4.67l-1.45-.57v-5.32h-1.91v2.75h-1.97v2.53h-2.72v2.53h-1.6l-.42-2.31h-2.06v-3.53h-1.45v-1.27h-1.3l-1.39.09v4.23h-1v-1.92l-.91-1.31-1.73,1.44v.13l-.82,3.88v-10.3h-1.36v7.77h-1.03l-.45-2.44h-3.06v5.8h-1.45v-3.58l-.51-2.79h-3.06v7.29h-1.3v-2.75h-4.15v4.28l-2.27-12.22h-3.06l-.61,12h-2.6v-5.28l-.67-.26-.27-1.53h-5.02l-.64,3.45h-1.88v-2.01l-.85.35v5.8h-2.45v-9.55l-1.21-.48v-4.1l-1.15-6.11-.97,5.24h-.94l-1.45-5.58.03-.35ZM269.86,35.45v.26h-.12c.03-.09.09-.17.12-.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3808-1",
    className: "cls-2",
    d: "M260.67,36.58v-7.76l-.61-.23-.64-7.17-.64,7.17-.61.23v7.76h2.55-.03Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g5284"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path5240",
    className: "cls-2",
    d: "M46.23,44.63v-14.24l.93-.27.16-.6c.6-.93.11-1.31,0-1.85-.33-1.04-.27-2.07.82-3.06.16-.87.6-1.69,1.31-2.29v-2.62l.82-5.4.82,5.4v2.62c.76.6,1.15,1.42,1.31,2.29,1.09.98,1.09,2.02.82,3.06-.11.55-.6.93,0,1.85l.16.6.93.27v14.24h-8.07Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g5280"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect5260",
    className: "cls-4",
    x: 48.42,
    y: 31.81,
    width: 1.2,
    height: 3.44
  }), /*#__PURE__*/React.createElement("rect", {
    id: "rect5260-6",
    className: "cls-4",
    x: 50.82,
    y: 31.81,
    width: 1.2,
    height: 3.44
  }))), /*#__PURE__*/React.createElement("path", {
    id: "path109413",
    className: "cls-2",
    d: "M81.53,44.51v-17.95l-.85-.5,1.2-1.2,2.17-5.12.12-.47v-1.84h-.67v-.2h.7v-1.32h.23v1.32h.7v.2h-.67v1.84l.12.47,2.17,5.12,1.2,1.2-.85.5v17.95h-5.62.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4547-5",
    className: "cls-5",
    d: "M35.23,37.46v-3.75l-.79-.23v3.87l.79.12h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4547-2",
    className: "cls-5",
    d: "M38.69,36.93v-2.52l-.53-.15v2.58l.53.09Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "rect21585",
    className: "cls-1",
    d: "M27.57,21.05l-10.87,8.2h-.21v.17l-1.04.79h1.04v4.25h.62l-1.04,10.16h22.9v-14.2l-12.53,1.67v-1.83h13.03l-11.87-9.2h-.04Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g21596"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "rect21012-7-3",
    className: "cls-3",
    points: "26.28 30.54 28.69 30.54 28.69 30.54 28.69 37.17 28.69 37.17 26.28 37.17 26.28 37.17 26.28 30.54 26.28 30.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "rect21012-7-9",
    className: "cls-3",
    points: "31.56 30.54 33.98 30.54 33.98 30.54 33.98 44.62 33.98 44.62 31.56 44.62 31.56 44.62 31.56 30.54 31.56 30.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "rect21012-7-5",
    className: "cls-3",
    points: "36.85 30.36 39.27 30.36 39.27 30.36 39.27 44.62 39.27 44.62 36.85 44.62 36.85 44.62 36.85 30.36 36.85 30.36"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path21574",
    className: "cls-3",
    d: "M29.65,25.17c0,1.12-.92,2.04-2.04,2.04s-2.04-.92-2.04-2.04h0c0-1.12.92-2.04,2.04-2.04s2.04.92,2.04,2.04h0Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "path4677-2",
    className: "cls-2",
    d: "M302.77,28.37c-2.02,0-4.04.87-6.06,2.6v12.79l22.55-.19v-12.6s-10.39.19-10.39.19c-2.02-1.83-4.04-2.74-6.06-2.79h-.05ZM334.89,28.37c-2.02,0-4.04.96-6.06,2.79l-9.91-.19v12.6l22.07.19v-12.79c-2.02-1.78-4.04-2.64-6.06-2.6h-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4679-6",
    className: "cls-2",
    d: "M300.75,28.9c.24-.48,0-1.01,0-1.49.29,0,.63-.24.87,0,.1-.87.14-1.68.1-2.55h-.34c-.19-.38-.1-.72,0-1.06l-.38-.14v-.24h.38l.38.29v.67l.48.1c-.29-.34-.1-.67,0-1.01h.38v1.01h.24s-.05.29-.05.29h-.53s0,2.21,0,2.21l.58.14v.48h.34l.19-.29.48.1.19-.14.87-.1.1-.43.19.1v.48l-.24.53-.1.29c0,.43-.05.91-.29.96-.29-.19-.29-.53-.24-.87h-.67c0,.63-.05.58-.1.63h-.24v-.63h-.63c.1.19.14.34,0,.38h-.38c-.24-.14-.1-.29,0-.43h-1.01v.48s-.58.24-.58.24h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect4642-1-0",
    className: "cls-3",
    d: "M298.69,33.57c.58.24,1.15.24,1.73,0h0v-2.5h0c-.53-.1-1.11-.24-1.73,0h0v2.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect4642-1-5-5",
    className: "cls-3",
    d: "M301.76,31.07c.58-.24,1.15-.24,1.73,0h0v2.5h0c-.53.1-1.11.24-1.73,0h0v-2.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect4642-1-7-9",
    className: "cls-3",
    d: "M304.99,31.07c.58-.24,1.15-.24,1.73,0h0v2.5h0c-.53.1-1.11.24-1.73,0h0v-2.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect4642-1-5-1-7",
    className: "cls-3",
    d: "M311,33.57c.34-.24.63-.24.96,0h0v2.5h0c-.29.1-.63.24-.96,0h0v-2.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect4642-1-5-1-8-1",
    className: "cls-3",
    d: "M315.9,35.35c.29-.19.53-.19.82,0h0v2.07h0c-.24.1-.48.19-.82,0h0v-2.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4679-6-5",
    className: "cls-2",
    d: "M336.82,28.81c-.24-.48,0-1.01,0-1.49-.29,0-.63-.24-.87,0-.1-.87-.14-1.68-.1-2.55h.34c.19-.38.1-.72,0-1.06l.38-.14v-.24h-.38l-.38.29v.67l-.48.1c.29-.34.1-.67,0-1.01h-.38v1.01h-.24s.05.29.05.29h.53s0,2.21,0,2.21l-.58.14v.48h-.34l-.19-.29-.48.1-.19-.14-.87-.1-.1-.43-.19.1v.48l.24.53.1.29c0,.43.05.91.29.96.29-.19.29-.53.24-.87h.67c0,.63.05.58.1.63h.24v-.63h.63c-.1.19-.14.34,0,.38h.38c.24-.14.1-.29,0-.43h1.01v.48s.58.24.58.24h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect4642-1-0-4",
    className: "cls-3",
    d: "M339.03,33.57c-.58.24-1.15.24-1.73,0h0v-2.5h0c.53-.1,1.11-.24,1.73,0h0v2.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect4642-1-5-5-4",
    className: "cls-6",
    d: "M335.9,31.07c-.58-.24-1.15-.24-1.73,0h0v2.5h0c.53.1,1.11.24,1.73,0h0v-2.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect4642-1-7-9-2",
    className: "cls-3",
    d: "M332.68,31.07c-.58-.24-1.15-.24-1.73,0h0v2.5h0c.53.1,1.11.24,1.73,0h0v-2.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect4642-1-5-1-7-8",
    className: "cls-3",
    d: "M326.67,33.57c-.34-.24-.63-.24-.96,0h0v2.5h0c.29.1.63.24.96,0h0v-2.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect4642-1-5-1-8-1-8",
    className: "cls-3",
    d: "M321.77,33.81c-.29-.19-.53-.19-.82,0h0v2.07h0c.24.1.48.19.82,0h0v-2.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4823",
    className: "cls-4",
    d: "M309.55,43.47h3.61v-3.03c0-2.21-3.37-2.84-3.61.05v2.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4823-6",
    className: "cls-4",
    d: "M331.82,43.67h2.26v-1.92c0-1.39-2.12-1.78-2.26,0v1.92Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "rect4845-9",
    className: "cls-3",
    points: "308.5 32.17 329.8 32.17 329.8 32.17 329.8 32.56 329.8 32.56 308.5 32.56 308.5 32.56 308.5 32.17 308.5 32.17"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4047"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3018",
    className: "cls-2",
    d: "M219.36,7.15v.79h-.37v2.08l-1.46-.21.17,2.71c-4.87,1.92-5.25,5.16-5.87,8.33-.79.42-1.54.54-2.29-.08-.08-.42-.37-.71-.92-.87l-.08-1.29h-1.08v1.37c-1.21.29-1.33,1.25-1.71,2l-.54.08v.5l.71.21-.08,1.62-2.29-.08c-.46.12-.58.58-.58,1.12v9.78l-12.49-4.62-17.86-.17-.17,13.32h47.59c0-23.98-.62-23.98-.58,0h46.84v-13.16h-16.99l-12.53,4.62v-9.78c0-.54-.08-1-.54-1.12l-2.29.08-.08-1.62.75-.21v-.5l-.58-.08c-.42-.79-.46-1.75-1.71-2v-1.37h-1.08l-.08,1.29c-.54.17-.83.46-.92.87-.75.62-1.54.5-2.29.08-.62-3.16-1-6.41-5.87-8.33l.17-2.71-1.5.21.08-2.08h-.46v-.79h-1Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "rect3020",
    className: "cls-3",
    points: "177.77 33.96 178.6 33.96 178.6 33.96 178.6 42.91 178.6 42.91 177.77 42.91 177.77 42.91 177.77 33.96 177.77 33.96"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "rect3020-8",
    className: "cls-3",
    points: "181.97 33.88 183.26 33.88 183.26 33.88 183.26 42.91 183.26 42.91 181.97 42.91 181.97 42.91 181.97 33.88 181.97 33.88"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "rect3020-8-6",
    className: "cls-3",
    points: "183.56 33.88 185.35 33.88 185.35 33.88 185.35 42.91 185.35 42.91 183.56 42.91 183.56 42.91 183.56 33.88 183.56 33.88"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "rect3020-8-6-4",
    className: "cls-3",
    points: "187.01 33.88 187.8 33.88 187.8 33.88 187.8 42.91 187.8 42.91 187.01 42.91 187.01 42.91 187.01 33.88 187.01 33.88"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "rect3020-8-6-4-1",
    className: "cls-3",
    points: "189.72 33.88 190.51 33.88 190.51 33.88 190.51 42.91 190.51 42.91 189.72 42.91 189.72 42.91 189.72 33.88 189.72 33.88"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "rect3020-8-6-4-2",
    className: "cls-3",
    points: "191.01 34.59 191.8 34.59 191.8 34.59 191.8 42.91 191.8 42.91 191.01 42.91 191.01 42.91 191.01 34.59 191.01 34.59"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "rect3020-8-6-4-4",
    className: "cls-3",
    points: "192.3 34.92 193.09 34.92 193.09 34.92 193.09 42.91 193.09 42.91 192.3 42.91 192.3 42.91 192.3 34.92 192.3 34.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "rect3020-8-6-4-21",
    className: "cls-3",
    points: "193.59 35.17 194.38 35.17 194.38 35.17 194.38 42.91 194.38 42.91 193.59 42.91 193.59 42.91 193.59 35.17 193.59 35.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "rect3020-8-6-4-13",
    className: "cls-3",
    points: "194.76 35.46 195.55 35.46 195.55 35.46 195.55 42.91 195.55 42.91 194.76 42.91 194.76 42.91 194.76 35.46 194.76 35.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "rect3020-8-6-4-10",
    className: "cls-3",
    points: "198.88 35.46 199.67 35.46 199.67 35.46 199.67 42.91 199.67 42.91 198.88 42.91 198.88 42.91 198.88 35.46 198.88 35.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "rect3020-8-6-4-28",
    className: "cls-3",
    points: "200.17 35.46 200.96 35.46 200.96 35.46 200.96 42.91 200.96 42.91 200.17 42.91 200.17 42.91 200.17 35.46 200.17 35.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "rect3020-8-6-4-3",
    className: "cls-3",
    points: "201.67 36.13 202.46 36.13 202.46 36.13 202.46 42.91 202.46 42.91 201.67 42.91 201.67 42.91 201.67 36.13 201.67 36.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "rect3020-8-6-4-45",
    className: "cls-3",
    points: "203.25 36.13 203.96 36.13 203.96 36.13 203.96 42.91 203.96 42.91 203.25 42.91 203.25 42.91 203.25 36.13 203.25 36.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "rect3020-8-6-4-45-2",
    className: "cls-3",
    points: "210.91 29.51 211.62 29.51 211.62 29.51 211.62 42.91 211.62 42.91 210.91 42.91 210.91 42.91 210.91 29.51 210.91 29.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "rect3020-8-6-4-45-2-3",
    className: "cls-3",
    points: "213.24 29.51 213.95 29.51 213.95 29.51 213.95 42.91 213.95 42.91 213.24 42.91 213.24 42.91 213.24 29.51 213.24 29.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "rect3020-8-6-4-45-2-9",
    className: "cls-3",
    points: "215.11 29.51 216.65 29.51 216.65 29.51 216.65 42.91 216.65 42.91 215.11 42.91 215.11 42.91 215.11 29.51 215.11 29.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "rect3020-8-6-4-45-2-8",
    className: "cls-6",
    points: "218.11 29.51 218.82 29.51 218.82 29.51 218.82 42.91 218.82 42.91 218.11 42.91 218.11 42.91 218.11 29.51 218.11 29.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "rect3020-8-6-4-45-2-8-6",
    className: "cls-3",
    points: "210.16 27.88 220.82 27.88 220.82 27.88 220.82 29.13 220.82 29.13 210.16 29.13 210.16 29.13 210.16 27.88 210.16 27.88"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "rect3020-8-6-4-45-2-8-6-8",
    className: "cls-3",
    points: "210.87 21.55 212.87 21.55 212.87 21.55 212.87 23.89 212.87 23.89 210.87 23.89 210.87 23.89 210.87 21.55 210.87 21.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "rect3020-8-6-4-45-2-8-6-8-3",
    className: "cls-3",
    points: "214.24 21.55 214.91 21.55 214.91 21.55 214.91 23.89 214.91 23.89 214.24 23.89 214.24 23.89 214.24 21.55 214.24 21.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "rect3020-8-6-4-45-2-8-6-8-6",
    className: "cls-3",
    points: "216.45 21.47 217.03 21.47 217.03 21.47 217.03 23.84 217.03 23.84 216.45 23.84 216.45 23.84 216.45 21.47 216.45 21.47"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "rect3020-8-6-4-45-2-8-6-8-6-1",
    className: "cls-6",
    points: "218.53 21.55 219.11 21.55 219.11 21.55 219.11 23.89 219.11 23.89 218.53 23.89 218.53 23.89 218.53 21.55 218.53 21.55"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4047-0"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "rect3020-9",
    className: "cls-3",
    points: "262 33.96 261.16 33.96 261.16 33.96 261.16 42.91 261.16 42.91 262 42.91 262 42.91 262 33.96 262 33.96"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "rect3020-8-2",
    className: "cls-3",
    points: "257.79 33.88 256.5 33.88 256.5 33.88 256.5 42.91 256.5 42.91 257.79 42.91 257.79 42.91 257.79 33.88 257.79 33.88"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "rect3020-8-6-6",
    className: "cls-3",
    points: "256.21 33.88 254.42 33.88 254.42 33.88 254.42 42.91 254.42 42.91 256.21 42.91 256.21 42.91 256.21 33.88 256.21 33.88"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "rect3020-8-6-4-33",
    className: "cls-3",
    points: "252.75 33.88 251.96 33.88 251.96 33.88 251.96 42.91 251.96 42.91 252.75 42.91 252.75 42.91 252.75 33.88 252.75 33.88"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "rect3020-8-6-4-1-5",
    className: "cls-3",
    points: "250 33.88 249.21 33.88 249.21 33.88 249.21 42.91 249.21 42.91 250 42.91 250 42.91 250 33.88 250 33.88"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "rect3020-8-6-4-2-5",
    className: "cls-3",
    points: "248.71 34.59 247.96 34.59 247.96 34.59 247.96 42.91 247.96 42.91 248.71 42.91 248.71 42.91 248.71 34.59 248.71 34.59"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "rect3020-8-6-4-4-6",
    className: "cls-3",
    points: "247.42 34.92 246.67 34.92 246.67 34.92 246.67 42.91 246.67 42.91 247.42 42.91 247.42 42.91 247.42 34.92 247.42 34.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "rect3020-8-6-4-21-4",
    className: "cls-3",
    points: "246.17 35.17 245.38 35.17 245.38 35.17 245.38 42.91 245.38 42.91 246.17 42.91 246.17 42.91 246.17 35.17 246.17 35.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "rect3020-8-6-4-13-4",
    className: "cls-3",
    points: "245.01 35.46 244.22 35.46 244.22 35.46 244.22 42.91 244.22 42.91 245.01 42.91 245.01 42.91 245.01 35.46 245.01 35.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "rect3020-8-6-4-10-3",
    className: "cls-3",
    points: "240.84 35.46 240.05 35.46 240.05 35.46 240.05 42.91 240.05 42.91 240.84 42.91 240.84 42.91 240.84 35.46 240.84 35.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "rect3020-8-6-4-28-2",
    className: "cls-3",
    points: "239.55 35.46 238.8 35.46 238.8 35.46 238.8 42.91 238.8 42.91 239.55 42.91 239.55 42.91 239.55 35.46 239.55 35.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "rect3020-8-6-4-3-0",
    className: "cls-3",
    points: "238.06 36.13 237.26 36.13 237.26 36.13 237.26 42.91 237.26 42.91 238.06 42.91 238.06 42.91 238.06 36.13 238.06 36.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "rect3020-8-6-4-45-21",
    className: "cls-3",
    points: "236.51 36.13 235.77 36.13 235.77 36.13 235.77 42.91 235.77 42.91 236.51 42.91 236.51 42.91 236.51 36.13 236.51 36.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "rect3020-8-6-4-45-2-7",
    className: "cls-3",
    points: "228.85 29.51 228.15 29.51 228.15 29.51 228.15 42.91 228.15 42.91 228.85 42.91 228.85 42.91 228.85 29.51 228.85 29.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "rect3020-8-6-4-45-2-3-1",
    className: "cls-3",
    points: "226.52 29.51 225.81 29.51 225.81 29.51 225.81 42.91 225.81 42.91 226.52 42.91 226.52 42.91 226.52 29.51 226.52 29.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "rect3020-8-6-4-45-2-9-4",
    className: "cls-3",
    points: "224.65 29.51 223.07 29.51 223.07 29.51 223.07 42.91 223.07 42.91 224.65 42.91 224.65 42.91 224.65 29.51 224.65 29.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "rect3020-8-6-4-45-2-8-0",
    className: "cls-3",
    points: "221.65 29.51 220.94 29.51 220.94 29.51 220.94 42.91 220.94 42.91 221.65 42.91 221.65 42.91 221.65 29.51 221.65 29.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "rect3020-8-6-4-45-2-8-6-1",
    className: "cls-3",
    points: "229.6 27.88 219.11 27.88 219.11 27.88 219.11 29.13 219.11 29.13 229.6 29.13 229.6 29.13 229.6 27.88 229.6 27.88"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "rect3020-8-6-4-45-2-8-6-8-8",
    className: "cls-3",
    points: "228.9 21.55 226.86 21.55 226.86 21.55 226.86 23.89 226.86 23.89 228.9 23.89 228.9 23.89 228.9 21.55 228.9 21.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "rect3020-8-6-4-45-2-8-6-8-3-2",
    className: "cls-3",
    points: "225.52 21.55 224.86 21.55 224.86 21.55 224.86 23.89 224.86 23.89 225.52 23.89 225.52 23.89 225.52 21.55 225.52 21.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "rect3020-8-6-4-45-2-8-6-8-6-7",
    className: "cls-3",
    points: "223.27 21.47 222.73 21.47 222.73 21.47 222.73 23.84 222.73 23.84 223.27 23.84 223.27 23.84 223.27 21.47 223.27 21.47"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "rect3020-8-6-4-45-2-8-6-8-6-1-5",
    className: "cls-3",
    points: "221.23 21.55 220.65 21.55 220.65 21.55 220.65 23.89 220.65 23.89 221.23 23.89 221.23 23.89 221.23 21.55 221.23 21.55"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g21004"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g5167"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path5159",
    className: "cls-2",
    d: "M252.26,43.11l.64-37.57.88-.7v-.47l.18.5.7.76.47,37.48v-.23"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path5161",
    className: "cls-1",
    d: "M254.31,3.4c0,.29-.2.5-.44.53-.26,0-.44-.23-.47-.5h0c0-.29.2-.53.44-.53.26,0,.44.23.47.5h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path5163",
    className: "cls-2",
    d: "M253.72,5.12l.12-4.28h-.64v-.12h.64v-.73h.12v.73h.61v.12h-.61v4.3h-.23v-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path5165",
    className: "cls-2",
    d: "M253.78,1.52l-.29.5.26.56h.2l.29-.53-.32-.53h-.18.03Z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "path5315",
    className: "cls-2",
    d: "M252.7,14.82c.76.23,1.46.18,2.17.06"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "g4645"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4622",
    className: "cls-2",
    d: "M289.32,43.89l4.67-.15v-15.11l.59-.48v-.19h-.26v-.3l-.48.11-.26-.07c.19-3.74-.59-6.44-3.33-7.07v-1.3l.3-.07v-.33h-.33l.07-.59h.26v-.3l-.96-.85v-2.7h.33v-.56h-.33v-1.81h-.59.07v1.78h-.33v.52h.3v2.7l-.89.85v.3h.22l.07.59h-.33v.33l.3.07v1.3c-2.74.63-3.56,3.33-3.37,7.07l-.22.07-.44-.11v.3h-.3v.19l.56.48v1.81h-1.81v-4.48h.63l-.07-.3h-.26l-.04-.3h-.37v-1.67c-.15-.7-.22-1.63-1.33-2v-1.22l-.15-1.19-.15,1.19-.07,1.19c-.33.19-1.04.78-1.11,1.93v1.7h-.52v.3h-.26v.37h.74v4.59c-.26.63-.33,1.41-.96,1.74h-.7v-4.04c-.48-.93-.59-1.93-2.22-2.85v-1.74l-.59-.3v-1.67c-.07-.44-.15-.96-.3,0l-.07,1.67-.52.37v1.67c-1.56.63-1.81,1.7-2.3,2.7v2.3l-.48.7-.56.07v-.63h-.3v.59l-.52.74v1.11h-2.04l-.07,11.04,16.37-.3h0l4.67.22"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4672"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "rect4652",
    className: "cls-3",
    points: "281.87 26.05 280.98 26.05 280.98 26.05 280.98 27.9 280.98 27.9 281.87 27.9 281.87 27.9 281.87 26.05 281.87 26.05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect4642-0",
    className: "cls-3",
    d: "M276.1,38.24c-.85-.48-1.7-.48-2.59,0h0v5.15h0c.81.26,1.3.3,2.59,0h0v-5.15Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "rect21858",
    className: "cls-3",
    points: "291.02 32.2 285.69 32.2 285.69 32.2 285.69 43.12 285.69 43.12 291.02 43.12 291.02 42.75 291.02 32.2 291.02 32.2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4512"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4195",
    className: "cls-2",
    d: "M106.03,41.56c.07-8.21.92-14.61,1.81-22.26,4.25-2.77,10.36-7.12,15.47-7.98,1.12,1.78,3.03,2.87,3.33,5.34l1.65.43.16,6.63,5.15.56.82,1.29h1.81l.99-1.29,7.32.13c14.81.3,13.92,3.43,16.62,5.9l.66,4.62,3.17.13.16,3.3-.16,5.47h-59.17l.16-2.31.03.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4197",
    className: "cls-4",
    d: "M132.55,41.7h3.86v-4.62c-.23-2.08-3.5-2.67-3.99,0l.13,4.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4197-0",
    className: "cls-4",
    d: "M127.57,41.7h3.23v-4.49c-.2-2.01-2.94-2.57-3.33,0l.1,4.49h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4197-2",
    className: "cls-4",
    d: "M122.72,41.7h3.07v-4.49c-.2-2.01-2.77-2.57-3.17,0l.1,4.49h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4197-3",
    className: "cls-4",
    d: "M117.9,41.7h2.9v-4.42c-.16-1.98-2.64-2.54-3,0l.1,4.42h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4197-5",
    className: "cls-4",
    d: "M114.08,41.7h2.24v-4.16c-.13-1.88-2.04-2.37-2.34,0l.07,4.16h.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4197-5-3",
    className: "cls-4",
    d: "M111.7,41.7h1.62v-3.96c-.1-1.78-1.45-2.28-1.65,0l.07,3.96h-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4197-5-6",
    className: "cls-4",
    d: "M109.69,41.7h1.12v-3.69c-.07-1.65-1.02-2.11-1.15,0v3.69h.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4197-5-9",
    className: "cls-5",
    d: "M108.04,41.7h.96v-3.4c-.07-1.52-.89-1.95-.99,0v3.4h.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4197-1",
    className: "cls-4",
    d: "M141.67,41.21h2.7v-3.56c-.17-1.6-2.46-2.04-2.79,0l.08,3.56h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4197-58",
    className: "cls-4",
    d: "M146.99,41.7h2.74v-4.06c-.16-1.81-2.47-2.34-2.84,0l.1,4.06h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4197-6",
    className: "cls-4",
    d: "M150.95,41.7h2.24v-3.79c-.13-1.72-2.04-2.18-2.34,0l.07,3.79h.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4197-4",
    className: "cls-4",
    d: "M154.28,41.7h1.95v-3.4c-.13-1.52-1.75-1.95-1.98,0l.07,3.4h-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4197-7",
    className: "cls-4",
    d: "M157.42,41.7h1.45v-3.23c-.1-1.45-1.32-1.85-1.48,0v3.23h.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4197-12",
    className: "cls-4",
    d: "M127.07,32.79h3.4v-3.53c-.2-1.58-3.07-2.04-3.5,0l.1,3.53h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4197-12-2",
    className: "cls-4",
    d: "M122.32,32.56h3.23v-3.13c-.2-1.42-2.94-1.78-3.33,0l.1,3.13h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4197-12-2-8",
    className: "cls-4",
    d: "M118.07,32.56h2.57v-2.8c-.16-1.25-2.34-1.62-2.67,0l.07,2.8h.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4197-12-2-8-6",
    className: "cls-4",
    d: "M114.54,32.92h2.11v-2.28c-.13-1.02-1.91-1.32-2.18,0l.07,2.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4197-12-2-8-6-1",
    className: "cls-4",
    d: "M111.97,32.99h1.78v-2.08c-.1-.92-1.62-1.19-1.81,0l.07,2.08h-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4197-12-2-8-6-1-2",
    className: "cls-4",
    d: "M109.66,33.29h1.78v-1.98c-.1-.89-1.62-1.12-1.81,0l.07,1.98h-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4197-12-0",
    className: "cls-4",
    d: "M123.51,24.61l2.9-.46v-3.53c-.16-1.55-2.64-1.62-3,.46l.1,3.53h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4197-12-2-3",
    className: "cls-4",
    d: "M119.45,25.01l2.77-.43v-3.13c-.16-1.39-2.51-1.42-2.84.43l.1,3.1-.03.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4197-12-2-8-5",
    className: "cls-4",
    d: "M115.79,25.57l2.21-.33v-2.8c-.13-1.25-2.01-1.32-2.28.36l.07,2.8v-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4197-12-2-8-6-14",
    className: "cls-4",
    d: "M112.79,26.39l1.78-.26v-2.28c-.1-1.02-1.62-1.06-1.85.3l.07,2.28v-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4197-12-2-8-6-1-4",
    className: "cls-4",
    d: "M110.58,26.82l1.52-.23v-2.08c-.1-.92-1.39-.99-1.55.23v2.08h.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4197-12-2-8-6-1-2-2",
    className: "cls-4",
    d: "M108.6,27.41l1.52-.23v-1.98c-.1-.89-1.39-.92-1.55.23v1.98h.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4197-1-3",
    className: "cls-4",
    d: "M137.79,31.6l3.23.26v-2.7c-.2-1.22-2.94-1.78-3.33-.26l.1,2.7h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4197-58-6",
    className: "cls-4",
    d: "M143.07,32l2.74.23v-2.57c-.16-1.19-2.47-1.68-2.84-.23l.1,2.57h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4197-6-4",
    className: "cls-4",
    d: "M147.06,32.33l2.24.16v-2.41c-.13-1.09-2.04-1.55-2.34-.2l.07,2.41.03.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4197-4-2",
    className: "cls-4",
    d: "M150.36,32.59l1.95.16v-2.14c-.13-.99-1.75-1.39-1.98-.16l.07,2.14h-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4197-7-3",
    className: "cls-4",
    d: "M153.52,32.82l1.45.1v-2.04c-.1-.92-1.32-1.29-1.48-.13v2.04l.03.03Z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "path4955",
    className: "cls-2",
    d: "M59.29,44.5v-16.56h16.87v16.56h-16.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4823-0",
    className: "cls-4",
    d: "M60.88,44.42h2.71v-4.1c0-2.95-2.55-3.86-2.71.08v4.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4823-0-6",
    className: "cls-4",
    d: "M71.78,44.5h2.71v-4.1c0-2.95-2.55-3.86-2.71.08v4.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4823-0-3",
    className: "cls-4",
    d: "M64.74,44.46h5.85v-5.93c.08-4.3-5.49-5.57-5.85.12v5.85-.04Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "rect5017",
    className: "cls-1",
    points: "57.42 28.78 78.07 28.78 78.07 28.78 78.07 30.65 78.07 30.65 57.42 30.65 57.42 30.65 57.42 28.78 57.42 28.78"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "rect5017-4",
    className: "cls-3",
    points: "61.28 28.98 73.69 28.98 73.69 28.98 73.69 30.09 73.69 30.09 61.28 30.09 61.28 30.09 61.28 28.98 61.28 28.98"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLandscapeRed);
export default __webpack_public_path__ + "static/media/landscape-red.efcffcf14a5e81467cd88acc9dc0fbb7.svg";
export { ForwardRef as ReactComponent };